"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var _require = require("../helpers/traversal"),
    closest = _require.closest;

var _require2 = require("../helpers/form-controls"),
    isDisabled = _require2.isDisabled;

var DefaultConstraintValidationImpl = require("../constraint-validation/DefaultConstraintValidation-impl").implementation;

var _require3 = require("../../utils"),
    mixin = _require3.mixin;

var _require4 = require("../helpers/form-controls"),
    getLabelsForLabelable = _require4.getLabelsForLabelable;

var HTMLButtonElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLButtonElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLButtonElementImpl);

  function HTMLButtonElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLButtonElementImpl);

    _this = _super.call(this, args, privateData);
    _this._customValidityErrorMessage = "";
    _this._labels = null;
    return _this;
  }

  _createClass(HTMLButtonElementImpl, [{
    key: "_activationBehavior",
    value: function _activationBehavior() {
      var form = this.form;

      if (form) {
        if (this.type === "submit" && !isDisabled(this)) {
          form._doSubmit();
        }
      }
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var valueAttr = this.getAttribute("value");
      return valueAttr === null ? "" : valueAttr;
    }
  }, {
    key: "_barredFromConstraintValidationSpecialization",
    value: function _barredFromConstraintValidationSpecialization() {
      return this.type === "reset" || this.type === "button";
    }
  }, {
    key: "labels",
    get: function get() {
      return getLabelsForLabelable(this);
    }
  }, {
    key: "form",
    get: function get() {
      return closest(this, "form");
    }
  }, {
    key: "type",
    get: function get() {
      var typeAttr = (this.getAttribute("type") || "").toLowerCase();

      switch (typeAttr) {
        case "submit":
        case "reset":
        case "button":
          return typeAttr;

        default:
          return "submit";
      }
    },
    set: function set(v) {
      v = String(v).toLowerCase();

      switch (v) {
        case "submit":
        case "reset":
        case "button":
          this.setAttribute("type", v);
          break;

        default:
          this.setAttribute("type", "submit");
          break;
      }
    }
  }]);

  return HTMLButtonElementImpl;
}(HTMLElementImpl);

mixin(HTMLButtonElementImpl.prototype, DefaultConstraintValidationImpl.prototype);
module.exports = {
  implementation: HTMLButtonElementImpl
};